import { Link } from "react-router-dom";
import Container from "@components/Container/Container";
import { useGetMastheadTopLinks } from "@hooks/useGetMastheadTopLinks";
import { cn } from "@util/helpers";

import LogoMasthead from "./LogoMasthead/LogoMasthead";
import type { NavigationA } from "./types";

export type MastheadProps = {
  prefix?: string;
  mastheadTitle?: string;
  mastheadCustomElement?: React.ReactElement;
  userDisplayName?: boolean;
  mastheadLinks?: NavigationA;
};

export default function HomepageMasthead() {
  const mastheadLinks = useGetMastheadTopLinks();

  return (
    <Container rootClassName="">
      <div className="relative hidden w-full flex-none pb-0 pt-6 lg:block">
        <div className="text-center uppercase">
          {mastheadLinks?.map((links, index) => {
            const childrenD = links?.section?.children || [];

            return (
              <div key={`masthead-links-${index}`}>
                <>
                  {childrenD.map((children, index) => {
                    const { link, label, key } = children;
                    return (
                      <Link
                        key={key}
                        to={`${link}?ref=masthead`}
                        rel="noopener noreferer"
                        reloadDocument
                        className={cn(
                          "border-l border-gray-175 px-[0.375rem] font-poppins text-4xs font-light text-gray-850 hover:underline",
                          { "border-none": index === 0 }
                        )}
                      >
                        {label}
                      </Link>
                    );
                  })}
                </>
              </div>
            );
          })}
        </div>
        <LogoMasthead rootClassName={"flex justify-center"} />
      </div>
    </Container>
  );
}
